var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_44796",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23427",
    "data-name": "Grupo 23427",
    transform: "translate(-480 -976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 480, 976)",
    filter: "url(#Rect\\xE1ngulo_44796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_44796-2",
    "data-name": "Rect\\xE1ngulo 44796",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(9 6)",
    fill: "#ed3b6b",
    opacity: 0.099
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66304",
    "data-name": "Trazado 66304",
    d: "M227.531,203.7a1.069,1.069,0,0,1-1.512,0l-2.268-2.268-2.268,2.268a1.069,1.069,0,0,1-1.512-1.512l2.268-2.269-2.268-2.268a1.069,1.069,0,0,1,1.512-1.512l2.268,2.268,2.268-2.268a1.069,1.069,0,1,1,1.512,1.512l-2.268,2.268,2.268,2.269A1.069,1.069,0,0,1,227.531,203.7Z",
    transform: "translate(275.248 792.076)",
    fill: "#ed3b6b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoError);
export default __webpack_public_path__ + "static/media/Icono-Error.53d0337c3548303a9755bef0bd087757.svg";
export { ForwardRef as ReactComponent };